import { Row, Col, Typography, Button, Card, Space } from "antd";
import {
  ArrowRightOutlined,
  HomeOutlined,
  UserOutlined,
  TrophyOutlined,
} from "@ant-design/icons";

const { Title, Paragraph } = Typography;

const Hero = ({ content, onViewPortfolio }) => {
  if (!content) {
    return null;
  }

  const metadata = content?.metadata || {};
  const stats = metadata.stats || [];
  const title = content.title || "";
  const subtitle = content.subtitle || "";
  const imageUrl = content.image_url || "";
  const featureCard = metadata.feature_card;
  const [firstTitleLine, ...restTitleLines] = title.split(" ");
  const highlightTitle = restTitleLines.join(" ");

  return (
    <section
      className="hero-section"
      id="home"
      style={{
        minHeight: "100vh",
        paddingTop: 80,
        background: "linear-gradient(to bottom right,#f9fafb,#ffffff)",
      }}
    >
      <div className="hero-inner" style={{ maxWidth: 1200, margin: "0 auto", padding: "60px 40px" }}>
        <Row gutter={[60, 60]} align="middle">
          {/* LEFT CONTENT */}
          <Col xs={24} lg={12}>
            <Space orientation="vertical" size="large">
              <Title className="hero-title" level={1} style={{ fontSize: 48 }}>
                {firstTitleLine}
                {highlightTitle && (
                  <span style={{ color: "#916847", display: "block" }}>
                    {highlightTitle}
                  </span>
                )}
              </Title>

              {subtitle && (
                <Paragraph style={{ fontSize: 18, maxWidth: 500 }}>
                  {subtitle}
                </Paragraph>
              )}

              {/* Buttons */}
              <Space wrap>
                <Button
                  type="primary"
                  size="large"
                  icon={<ArrowRightOutlined />}
                  onClick={onViewPortfolio}
                >
                  {metadata.primary_cta}
                </Button>

                <Button size="large" href="#contact">
                  {metadata.secondary_cta}
                </Button>
              </Space>

              {/* Stats */}
              {!!stats.length && (
                <Row className="hero-stats" gutter={[16, 16]} style={{ marginTop: 40 }}>
                  {stats.map((stat, index) => {
                    const StatIcon = [HomeOutlined, UserOutlined, TrophyOutlined][index] || HomeOutlined;

                    return (
                      <Col span={8} key={stat.label}>
                        <Card variant={false} style={{ textAlign: "center" }}>
                          <StatIcon style={{ fontSize: 24, color: "#916847" }} />
                          <h3 style={{ margin: 10 }}>{stat.value}</h3>
                          <p>{stat.label}</p>
                        </Card>
                      </Col>
                    );
                  })}
                </Row>
              )}
            </Space>
          </Col>

          {/* RIGHT IMAGE */}
          {imageUrl && (
          <Col className="hero-image-column" xs={24} lg={12}>
                <div className="hero-image"
              style={{
                position: "relative",
                borderRadius: 20,
                overflow: "hidden",
                boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
              }}
            >
              <img
                src={imageUrl}
                alt="Modern interior"
                style={{
                  width: "100%",
                  height: 600,
                  objectFit: "cover",
                }}
              />

              {/* Overlay */}
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  background:
                    "linear-gradient(to top, rgba(0,0,0,0.2), transparent)",
                }}
              />
            </div>

            {/* Floating Card */}
            {featureCard && (
              <Card className="hero-feature-card"
                style={{
                  position: "absolute",
                  bottom: -20,
                  left: -20,
                  width: 260,
                  borderRadius: 16,
                }}
              >
                <Space>
                  {featureCard.image_url && (
                    <img
                      src={featureCard.image_url}
                      alt={featureCard.title || "Feature"}
                      style={{
                        width: 60,
                        height: 60,
                        borderRadius: 12,
                        objectFit: "cover",
                      }}
                    />
                  )}
                  <div>
                    <strong>{featureCard.title}</strong>
                    <p style={{ fontSize: 12, color: "#777" }}>
                      {featureCard.subtitle}
                    </p>
                  </div>
                </Space>
              </Card>
            )}
          </Col>
          )}
        </Row>
      </div>
    </section>
  );
};

export default Hero;
